/**
 * Releasit COD — first-open readiness (non-blocking)
 *
 * NEVER preventDefault / stopPropagation on buy-now clicks — that breaks
 * reopen after close (Releasit ignores synthetic re-clicks / desyncs).
 *
 * Responsibilities:
 *  1) Soft-hydrate Releasit on buy intent
 *  2) Clear stale cart EARLY (pointerdown) so QO can mount
 *  3) After modal open: wait for quantity offers; if multi-item cart
 *     blocked QO, rebuild cart with current PDP product and reopen once
 */
(function () {
  'use strict';

  if (window.__rsiFormOpenGuard) return;
  window.__rsiFormOpenGuard = true;

  var watchTimer = null;
  var watchAttempts = 0;
  var MAX_WATCH = 30;
  var lastClearAt = 0;
  var clearPromise = null;
  var recovering = false;
  var lastRecoverAt = 0;

  function formOpen() {
    return !!(
      document.querySelector('#_rsi-cod-form-modal._rsi-cod-form-modal-open') &&
      document.querySelector('#_rsi-cod-form-modal-form')
    );
  }

  function hasQuantityOffers() {
    return !!document.querySelector(
      '#_rsi-cod-form-modal-form ._rsi-quantity-offers-offer-container, #rsi-cod-form-quantity-offers-hook ._rsi-quantity-offers-offer-container'
    );
  }

  function countFormLineItems() {
    return document.querySelectorAll('#_rsi-cod-form-modal-form ._rsi-modal-line-item').length;
  }

  function isProductPage() {
    return !!(window.meta && window.meta.product && window.meta.product.id);
  }

  function getCurrentVariantId() {
    var formId = document.querySelector(
      'form[action*="/cart/add"] [name="id"], product-form [name="id"], [name="id"][data-productid], input[name="id"]'
    );
    if (formId && formId.value) return String(formId.value);

    try {
      if (window.meta && window.meta.selectedVariantId) return String(window.meta.selectedVariantId);
      if (window.meta && window.meta.product && window.meta.product.variants && window.meta.product.variants[0]) {
        return String(window.meta.product.variants[0].id);
      }
    } catch (e) { /* ignore */ }

    var urlMatch = String(location.search || '').match(/[?&]variant=(\d+)/);
    if (urlMatch) return urlMatch[1];
    return null;
  }

  function runCustomSetup(forceVariants) {
    if (typeof window._rsiProcessQuantityOfferVariants === 'function') {
      window._rsiProcessQuantityOfferVariants(!!forceVariants);
    }
    if (typeof window._rsiEnsureStickyHeader === 'function') {
      window._rsiEnsureStickyHeader();
    }
    if (typeof window._rsiUpdateOrderSummary === 'function') {
      window._rsiUpdateOrderSummary();
    }
    if (typeof window._rsiLayoutQuantityOfferVariants === 'function') {
      window._rsiLayoutQuantityOfferVariants();
    }
    if (typeof window._rsiSyncQoFreeShipping === 'function') {
      window._rsiSyncQoFreeShipping();
    }
  }

  function clearCartRequest() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    }).catch(function () {
      return null;
    });
  }

  function addCurrentVariantRequest(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
      }),
    }).catch(function () {
      return null;
    });
  }

  /**
   * Releasit addMode=product-plus-cart: si el carrito ya tenía otra PDP
   * (ej. licuadora), el form abre en modo carrito multi-ítem y NO monta QO.
   * Limpiar temprano reduce esa carrera.
   */
  function softClearStaleCart() {
    if (!isProductPage()) return Promise.resolve(false);

    var now = Date.now();
    if (now - lastClearAt < 800 && clearPromise) return clearPromise;
    lastClearAt = now;

    clearPromise = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return false;
        return clearCartRequest().then(function () {
          return true;
        });
      })
      .catch(function () {
        return false;
      });

    return clearPromise;
  }

  function findBuyNowButton() {
    return document.querySelector(
      'a[href="/rsi-gempages-overwrite"], a[href*="rsi-gempages-overwrite"],' +
        '._rsi-buy-now-button-product, #rsi_buy_now_button, #_rsi-buy-now-button-overwrite,' +
        '[id*="rsi_buy_now"]'
    );
  }

  function isBuyNowTarget(el) {
    if (!el || !el.closest) return null;
    return el.closest(
      'a[href="/rsi-gempages-overwrite"], a[href*="rsi-gempages-overwrite"],' +
        '._rsi-buy-now-button-product, #rsi_buy_now_button, ._rsi-buy-now-button,' +
        '[id*="rsi_buy_now"], #_rsi-buy-now-button-overwrite'
    );
  }

  /**
   * Form abierto con 2+ line items y sin QO = carrito sucio bloqueó ofertas.
   * Rebuild: clear → add variante actual → cerrar → reabrir buy-now una vez.
   */
  function maybeRecoverStaleCartBlockingQo() {
    if (recovering) return;
    if (!formOpen() || hasQuantityOffers()) return;
    if (!isProductPage()) return;
    if (countFormLineItems() < 2) return;

    var now = Date.now();
    if (now - lastRecoverAt < 8000) return;
    lastRecoverAt = now;

    var variantId = getCurrentVariantId();
    if (!variantId) return;

    recovering = true;

    clearCartRequest()
      .then(function () {
        return addCurrentVariantRequest(variantId);
      })
      .then(function () {
        if (typeof window._rsiForceCloseCodForm === 'function') {
          window._rsiForceCloseCodForm();
        } else {
          var closeBtn = document.querySelector('#_rsi-cod-form-modal-close');
          if (closeBtn) {
            try {
              closeBtn.click();
            } catch (e) { /* ignore */ }
          }
        }

        setTimeout(function () {
          recovering = false;
          var btn = findBuyNowButton();
          if (btn && !formOpen()) {
            try {
              btn.click();
            } catch (e2) { /* ignore */ }
          }
        }, 450);
      })
      .catch(function () {
        recovering = false;
      });
  }

  // pointerdown: empezar clear ANTES de que Releasit arme el form
  document.addEventListener(
    'pointerdown',
    function (e) {
      var btn = isBuyNowTarget(e.target);
      if (!btn) return;
      if (typeof window.__rsiHydrateReleasit === 'function') {
        window.__rsiHydrateReleasit();
      }
      softClearStaleCart();
    },
    true
  );

  // click: hydrate + clear (sin bloquear el click)
  document.addEventListener(
    'click',
    function (e) {
      var btn = isBuyNowTarget(e.target);
      if (!btn) return;

      if (typeof window.__rsiHydrateReleasit === 'function') {
        window.__rsiHydrateReleasit();
      }
      softClearStaleCart();
    },
    true
  );

  function stopWatch() {
    if (watchTimer) {
      clearInterval(watchTimer);
      watchTimer = null;
    }
    watchAttempts = 0;
  }

  function startWatch() {
    stopWatch();
    watchAttempts = 0;

    watchTimer = setInterval(function () {
      watchAttempts += 1;
      if (!formOpen()) {
        stopWatch();
        return;
      }

      if (hasQuantityOffers()) {
        runCustomSetup(watchAttempts <= 3);
        if (typeof window._rsiSyncQoFreeShipping === 'function') {
          window._rsiSyncQoFreeShipping();
        }
        if (watchAttempts >= 8) stopWatch();
        return;
      }

      if (watchAttempts === 1 || watchAttempts === 5 || watchAttempts === 10 || watchAttempts === 15) {
        runCustomSetup(false);
      }

      // ~1.2s / ~2s: si hay multi-ítem sin QO, recuperar
      if (watchAttempts === 6 || watchAttempts === 10) {
        maybeRecoverStaleCartBlockingQo();
      }

      if (watchAttempts >= MAX_WATCH) {
        runCustomSetup(false);
        maybeRecoverStaleCartBlockingQo();
        stopWatch();
      }
    }, 200);
  }

  var mo = new MutationObserver(function () {
    if (formOpen()) {
      if (!watchTimer) startWatch();
    } else {
      stopWatch();
    }
  });

  function boot() {
    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    if (formOpen()) startWatch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var busHook = setInterval(function () {
    if (!window._rsiModalBus || window._rsiModalBus.__openGuardHooked) return;
    window._rsiModalBus.__openGuardHooked = true;
    var originalOpen = window._rsiModalBus.open.bind(window._rsiModalBus);
    window._rsiModalBus.open = function () {
      originalOpen();
      startWatch();
    };
    clearInterval(busHook);
  }, 500);
  setTimeout(function () {
    clearInterval(busHook);
  }, 20000);
})();
